import scrollTo from './scrollTo'

// скролл к элементу
const scrollToElement = (id) => {
  const elementToScroll = document.querySelector(`#${id}`);
  scrollTo(elementToScroll.getBoundingClientRect().top + window.pageYOffset - 10, 500);
}

export default scrollToElement;